import './lesson-accordion.css';

import { DsIcon } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect, useState } from 'react';

import { ClassroomViewModel, Lesson, Video } from '@/presentation/screens/classroom/classroom.vm';
import { ButtonContainer } from '@/presentation/shared-components/button';
import { LessonTitle } from '@/presentation/shared-components/text';

import LessonExercise from './exercise';
import LessonContentContainer from './lesson-content';
import SupportMaterialLink from './support-material-link';

type LessonAccordionParams = {
  lesson: Lesson;
};

const LessonAccordionContainer: React.FC<LessonAccordionParams> = ({
  lesson,
}: LessonAccordionParams) => {
  const vm = useViewModel(ClassroomViewModel);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(lesson.guid === vm.currentLesson?.guid);
  }, [vm.currentLesson]);

  const completedVideosCount = vm.getCompletedVideoCountForLesson(lesson);
  const totalVideos = vm.getVideoCountForLesson(lesson);

  const toggleLesson = () => {
    setOpen(!open);
  };

  const handleClick = () => {
    toggleLesson();
  };

  return (
    <>
      <li className="lesson-item">
        {/* TODO: The lesson open / close is the same an accordion and must become a separate component in the UI library */}
        <ButtonContainer
          className={`${open ? 'lesson-button opened-lesson' : 'lesson-button'}`}
          onClick={handleClick}
          ariaLabel={`${
            open ? 'Fechar atividades da aula' : `Ver atividades da aula: ${lesson.name}`
          }`}
        >
          <div className="lesson-description">
            <div className="lesson-teacher">
              <LessonTitle className="lesson-title">{lesson.name}</LessonTitle>
              <div className="lesson-info-wrapper">
                <p className="lesson-progress">
                  {completedVideosCount} / {totalVideos}
                </p>
                <DsIcon color="gray-dark" image={open ? 'arrow-drop-up' : 'arrow-drop-down'} />
              </div>
            </div>
            <div>
              <p className="teacher-name">{open ? lesson.teacher : ''}</p>
            </div>
          </div>
        </ButtonContainer>
        <div className={`lesson-data ${open ? 'show' : 'hide'}`}>
          <div className="lesson-contents">
            {open &&
              lesson.videos?.map((video: Video, index: number) => (
                <LessonContentContainer key={index} lesson={lesson} video={video} />
              ))}
          </div>

          {open && lesson?.exercisesLesson?.length > 0
            ? lesson?.exercisesLesson.map((exercise) => (
                <LessonExercise
                  key={lesson.guid}
                  classroom={vm.classroom}
                  lesson={lesson}
                  url={`/answer/${exercise.exercises_guid}/lesson/${exercise.lesson_guid}`}
                  label="Exercício"
                  exercise={exercise}
                  openExercise={vm.setHasExerciseOpen}
                />
              ))
            : null}
          {lesson.supportMaterial?.url && (
            <SupportMaterialLink
              classroom={vm.classroom}
              lesson={lesson}
              supportMaterial={lesson.supportMaterial}
            />
          )}
        </div>
      </li>
    </>
  );
};

export default observer(LessonAccordionContainer);
